import React from 'react';
import { createRoot } from 'react-dom/client';
import { AuthProvider } from './state/AuthProvider';
import { PwaNav } from './ui/PwaNav';
import { PwaContent } from './ui/PwaContent';
import './style.css';

function readApiBaseUrl(): string {
  const contentRoot = document.getElementById('ww-pwa-content');
  const navRoot = document.getElementById('ww-pwa-nav');

  return contentRoot?.dataset.apiBaseUrl ?? navRoot?.dataset.apiBaseUrl ?? '/api';
}

const apiBaseUrl = readApiBaseUrl();

const navRoot = document.getElementById('ww-pwa-nav');
const contentRoot = document.getElementById('ww-pwa-content');

if (navRoot) {
  createRoot(navRoot).render(
      <React.StrictMode>
        <AuthProvider apiBaseUrl={apiBaseUrl}>
          <PwaNav />
        </AuthProvider>
      </React.StrictMode>,
  );
}

if (contentRoot) {
  createRoot(contentRoot).render(
      <React.StrictMode>
        <AuthProvider apiBaseUrl={apiBaseUrl}>
          <PwaContent />
        </AuthProvider>
      </React.StrictMode>,
  );
}

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/sw.js', { scope: '/' }).catch((error) => {
    console.warn('ww-pwa: Service Worker konnte nicht registriert werden', error);
  });
}
